module.exports = __webpack_public_path__ + "static/media/image16.580885df.png";